<template>
  <div id="Lgx02667342160782000390436">
    <div class="relative flex main-border rounded-lg bg-dark p-10">
      <img
        src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/02667342160782000390436/graphic.png"
        alt="Logo"
        draggable="false"
        width="100%"
        height="100%"
      />

      <span class="router" style="width: 9.7%; height: 10.5%; bottom: 39%; left: 29.5%" @click="selectRouter(0)" />
      <span class="router" style="width: 9.7%; height: 10.5%; bottom: 39%; left: 52.55%" @click="selectRouter(2)" />
      <span class="router" style="width: 9.7%; height: 10.5%; bottom: 39%; left: 68.6%" @click="selectRouter(1)" />
    </div>

    <movable-popup
      refVal="portConfigurationPopup"
      :title="`Router ${selectedRouter == 0 ? 'A' : selectedRouter == 1 ? 'B' : 'C'}`"
      :active="selectedRouter !== null"
      v-on:close="selectedRouter = null"
      style="width: 40rem"
    >
      <template v-slot:content>
        <div class="flex flex-col gap-3">
          <span class="flex items-center gap-3">
            <vs-button
              size="small"
              :class="activeTab !== 0 && 'text-black'"
              :color="activeTab == 0 ? 'primary' : 'dark'"
              @click="activeTab = 0"
              >Routing Table</vs-button
            >
            <vs-button
              size="small"
              :class="activeTab !== 1 && 'text-black'"
              :color="activeTab == 1 ? 'primary' : 'dark'"
              @click="activeTab = 1"
              >Routing Configuration</vs-button
            >
          </span>

          <div v-if="activeTab === 0" class="bg-dark p-3 main-border rounded-lg">
            <span class="terminal-line text-grey"
              >Router-{{ selectedRouter == 0 ? 'A' : selectedRouter == 1 ? 'B' : 'C' }}# show ip route</span
            >
            <span class="terminal-line text-grey" v-html="staticTableOutput" />
            <span v-if="selectedRouter === 0" class="terminal-line text-grey" v-html="routerAOutput" />
            <span v-if="selectedRouter === 1" class="terminal-line text-grey" v-html="routerBOutput" />
            <span v-if="selectedRouter === 2" class="terminal-line text-grey" v-html="routerCOutput" />
          </div>

          <div v-if="activeTab === 1" class="">
            <span class="flex items-center gap-6 mt-3">
              <p
                class="font-medium text-lg"
                :class="{
                  'text-success': configurations[selectedRouter].problemFoundCorrect,
                  'text-danger': configurations[selectedRouter].problemFoundCorrect === false,
                }"
              >
                Was a problem found?
              </p>
              <span class="flex items-center gap-3">
                <vs-switch v-model="configurations[selectedRouter].problemFoundValue" color="success" />
                <span class="ml-2">{{ configurations[selectedRouter].problemFoundValue ? 'Yes' : 'No' }}</span>
              </span>
            </span>

            <div class="flex flex-col gap-4 bg-dark p-4 rounded-lg mt-5">
              <p class="font-medium text-2xl">Install Static Route</p>
              <span class="flex items-center w-full">
                <p class="font-medium text-lg" style="width: 13.5rem">Destination Prefix:</p>
                <vs-input
                  v-model="configurations[selectedRouter].prefixValue"
                  class="flex"
                  style="flex-grow: 1"
                  :class="{
                    correct: configurations[selectedRouter].prefixCorrect,
                    invalid: configurations[selectedRouter].prefixCorrect === false,
                  }"
                />
              </span>

              <span class="flex items-center w-full">
                <p class="font-medium text-lg" style="width: 13.5rem">Destination Mask Prefix:</p>
                <vs-input
                  v-model="configurations[selectedRouter].prefixMaskValue"
                  class="flex"
                  style="flex-grow: 1"
                  :class="{
                    correct: configurations[selectedRouter].prefixMaskCorrect,
                    invalid: configurations[selectedRouter].prefixMaskCorrect === false,
                  }"
                />
              </span>

              <span class="flex items-center w-full">
                <p class="font-medium text-lg" style="width: 21.8rem">Interface:</p>
                <v-select
                  :options="interfaces"
                  v-model="configurations[selectedRouter].interfaceValue"
                  class="w-full"
                  :class="{
                    correct: configurations[selectedRouter].interfaceCorrect,
                    invalid: configurations[selectedRouter].interfaceCorrect === false,
                  }"
                />
              </span>
            </div>
          </div>
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      selectedRouter: null,
      activeTab: 0,

      interfaces: ['Gi1', 'Gi2', 'Gi3', 'Gi4'],

      configurations: [
        {
          problemFoundValue: false,
          problemFoundAnswer: true,
          problemFoundCorrect: null,
          prefixValue: null,
          prefixAnswer: '10.0.5.0',
          prefixCorrect: null,
          prefixMaskValue: null,
          prefixMaskAnswer: '255.255.255.0',
          prefixMaskCorrect: null,
          interfaceValue: null,
          interfaceAnswer: 'Gi1',
          interfaceCorrect: null,
        },
        {
          problemFoundValue: false,
          problemFoundAnswer: true,
          problemFoundCorrect: null,
          prefixValue: null,
          prefixAnswer: '10.0.1.0',
          prefixCorrect: null,
          prefixMaskValue: null,
          prefixMaskAnswer: '255.255.255.0',
          prefixMaskCorrect: null,
          interfaceValue: null,
          interfaceAnswer: 'Gi2',
          interfaceCorrect: null,
        },
        {
          problemFoundValue: false,
          problemFoundAnswer: false,
          problemFoundCorrect: null,
          prefixValue: null,
          prefixAnswer: null,
          prefixCorrect: null,
          prefixMaskValue: null,
          prefixMaskAnswer: null,
          prefixMaskCorrect: null,
          interfaceValue: null,
          interfaceAnswer: null,
          interfaceCorrect: null,
        },
      ],

      staticTableOutput: `
      <br /><br />Codes: L - local, C - connected, S - static, R - RIP, M - mobile, B - BGP<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;D - EIGRP, EX - EIGRP external, O - OSPF, IA - OSPF inter area<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;N1 - OSPF NSSA external type 1, N2 - OSPF NSSA external type 2<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;E1 - OSPF external type 1, E2 - OSPF external type 2, m - OMP<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;n - NAT, Ni - NAT inside, No - NAT outside, Nd - NAT DIA<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;i - IS-IS, su - IS-IS summary, L1 - IS-IS level-1, L2 - IS-IS level-2<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ia - IS-IS inter area, * - candidate default, U - per-user static route<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;H - NHRP, G - NHRP registered, g - NHRP registration summary<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;o - ODR, P - periodic downloaded static route, l - LISP<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a - application route<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ - replicated route, % - next hop override, p - overrides from PFR<br /><br />
      `,

      routerAOutput: `Gateway of last resort is 0.0.0.0 to network 0.0.0.0<br /><br />
            S*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.0.0.0/0 is directly connected, GigabitEthernet3<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.0.0/8 is variably subnetted, 4 subnets, 2 masks<br />
            C&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.4.0/22 is directly connected, GigabitEthernet2<br />
            C&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.6.0/24 is directly connected, GigabitEthernet2<br />
            L&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.6.1/32 is directly connected, GigabitEthernet2<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;172.16.0.0/16 is variably subnetted, 2 subnets, 2 masks<br />
            C&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;172.16.27.0/30 is directly connected, GigabitEthernet3<br />
            L&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;172.16.27.1/32 is directly connected, GigabitEthernet3<br />
            `,

      routerBOutput: `Gateway of last resort is 0.0.0.0 to network 0.0.0.0<br /><br />
            S*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.0.0.0/0 is directly connected, GigabitEthernet1<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.0.0/8 is variably subnetted, 4 subnets, 2 masks<br />
            C&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.0.0/22 is directly connected, GigabitEthernet3<br />
            L&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.0.1/32 is directly connected, GigabitEthernet3<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;172.16.0.0/16 is variably subnetted, 2 subnets, 2 masks<br />
            C&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;172.16.27.4/30 is directly connected, GigabitEthernet1<br />
            L&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;172.16.27.5/32 is directly connected, GigabitEthernet1<br />
            `,

      routerCOutput: `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.0.0/8 is variably subnetted, 4 subnets, 2 masks<br />
            S&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.0.0/22 [1/0] via GigabitEthernet1<br />
            S&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.4.0/22 [1/0] via GigabitEthernet2<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;172.16.0.0/16 is variably subnetted, 4 subnets, 2 masks<br />
            C&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;172.16.27.0/30 is directly connected, GigabitEthernet2<br />
            L&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;172.16.27.2/32 is directly connected, GigabitEthernet2<br />
            C&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;172.16.27.4/30 is directly connected, GigabitEthernet1<br />
            L&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;172.16.27.6/32 is directly connected, GigabitEthernet1<br />
            `,
    };
  },
  methods: {
    selectRouter(router) {
      this.selectedRouter = router;
      this.activeTab = 0;
    },
    markSimulation() {
      let totalScore = 0;

      console.log(this.configurations);

      this.configurations.forEach((configuration, index) => {
        if (configuration.problemFoundValue === configuration.problemFoundAnswer) {
          this.configurations[index].problemFoundCorrect = true;
          totalScore++;
        } else {
          this.configurations[index].problemFoundCorrect = false;
        }

        if (configuration.prefixValue === configuration.prefixAnswer) {
          this.configurations[index].prefixCorrect = true;
          totalScore++;
        } else {
          this.configurations[index].prefixCorrect = false;
        }

        if (configuration.prefixMaskValue === configuration.prefixMaskAnswer) {
          this.configurations[index].prefixMaskCorrect = true;
          totalScore++;
        } else {
          this.configurations[index].prefixMaskCorrect = false;
        }

        if (configuration.interfaceValue === configuration.interfaceAnswer) {
          this.configurations[index].interfaceCorrect = true;
          totalScore++;
        } else {
          this.configurations[index].interfaceCorrect = false;
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    vSelect,
    MovablePopup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
#Lgx02667342160782000390436 {
  .router {
    position: absolute;
    cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto;
  }

  .terminal-line {
    color: #f8f8f2;
    font-family: 'Fira Code', monospace;
    font-size: 0.875rem;
    line-height: 1.5;
    margin: 0.25rem 0;
  }

  .correct {
    border: 1px solid #31b952 !important;
    border-radius: 0.35rem;
  }

  .invalid {
    border: 1px solid #c93738 !important;
    border-radius: 0.35rem;
  }

  .vs-con-input {
    width: 100%;
  }
}
</style>
